import PropTypes from "prop-types";
import { Backdrop } from "@mui/material";

export default function BackdropContainer(props) {
	const { children, open } = props;
	return (
		<Backdrop
			sx={{
				zIndex: 9999,
				color: "#fff",
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				backdropFilter: "blur(7px)",
			}}
			open={open}
		>
			{children}
		</Backdrop>
	);
}

BackdropContainer.propTypes = {
	children: PropTypes.node,
	open: PropTypes.bool,
};
